import { MeetingNotes } from 'modules/calendar/components/MeetingNotes';

type CandidateProfileAnalysisInterviewTranscriptsProps = {
  calendarBookingId: string | null;
};

export const CandidateProfileAnalysisInterviewTranscripts: React.FC<
  CandidateProfileAnalysisInterviewTranscriptsProps
> = ({ calendarBookingId }) => {
  if (!calendarBookingId) {
    return null;
  }

  return <MeetingNotes calendarBookingId={calendarBookingId} />;
};
